// The deer_activity step Result (API-3891) as the days the HuntWind Deer Activity card draws
// (WEB-7158, hunt-wind/deer-activity/model.js), so the chat shows the same card. The server sends
// PascalCase, with the "Why this score" rows and the caveat already worded, and says outright
// whether a day is the seasonal pattern; the model takes those as given.

import { camelKeys } from './keys'

export const deerActivityDays = result => {
  if (!result || result.Kind !== 'deer_activity') return null
  const days = (Array.isArray(result.Days) ? result.Days : []).filter(d => d && d.Date && Array.isArray(d.Curve) && d.Curve.length > 0)
  if (days.length === 0) return null
  return days.map(d => {
    const { curve, date, why, sunrise, sunset, weather, seasonal, ...context } = camelKeys(d)
    return {
      date,
      context: {
        ...context,
        sunriseLocal: sunrise,
        sunsetLocal: sunset,
        // The model reads a day without weather as the seasonal pattern.
        weather: seasonal ? null : weather || {},
        whyRows: (Array.isArray(why) ? why : []).filter(r => r && r.text).map(r => ({ key: String(r.key || 'note').toUpperCase(), text: String(r.text) })),
        caveat: result.Caveat || null
      },
      curve
    }
  })
}
